export const ROUTES = {
  HOME: '/',
  QUOTE: '/quote',
  GET_ESTIMATE: '/get-estimate',
  /** @deprecated Prefer SERVICES.kitchen - kept for legacy links */
  KITCHEN: '/kitchen',
  BATHROOM: '/bathroom',
  ADU: '/adu',
  OUTDOOR: '/outdoor',
  SERVICE_AREAS: '/service-areas',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  ABOUT: '/#about',
  LOCATIONS: '/locations',
  SERVICES: '/services',
} as const;

export const servicePath = (slug: string) => `${ROUTES.SERVICES}/${slug}`;
export const locationPath = (slug: string) => `${ROUTES.LOCATIONS}/${slug}`;
export const serviceCityPath = (serviceSlug: string, citySlug: string) =>
  `${ROUTES.SERVICES}/${serviceSlug}/${citySlug}`;
